export function checkTokenValid(){
    if (localStorage.getItem('token') == null || localStorage.getItem('token') == '') {
        return false;
    }

    let now = new Date();
    let tokenExpiration = new Date(parseInt(localStorage.getItem('token_expiration')!) * 1000);
    return tokenExpiration > now;
}